import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Autocomplete from "react-google-autocomplete";
import { biasAwayFromNYBounds, GOOGLE_API_KEY, parseAddress, } from "../../services/googleAddress";
export default function AutoAddress(_a) {
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur;
    var fieldConfig = ((field === null || field === void 0 ? void 0 : field.config) || {});
    var _b = useState(false), blurred = _b[0], setBlurred = _b[1];
    var _c = useState(false), isValidSelection = _c[0], setIsValidSelection = _c[1];
    var _d = useState((field === null || field === void 0 ? void 0 : field.fieldValue) || ""), inputValue = _d[0], setInputValue = _d[1];
    var invalidate = function () {
        setInputValue("");
        setIsValidSelection(false);
        onChange("", true);
        onBlur();
    };
    var handlePlaceSelect = function (place) {
        if (!(place === null || place === void 0 ? void 0 : place.address_components)) {
            setIsValidSelection(false);
            return;
        }
        var hasStreetNumber = place.address_components.some(function (c) {
            return c.types.includes("street_number");
        });
        if (!hasStreetNumber) {
            invalidate();
            return;
        }
        var parsedAddress = parseAddress(place);
        if (field.config.NotNY && parsedAddress.state === "NY") {
            invalidate();
            return;
        }
        var fullAddress = "".concat(parsedAddress.street, ", ").concat(parsedAddress.city, ", ").concat(parsedAddress.state, " ").concat(parsedAddress.zip);
        setIsValidSelection(true);
        setInputValue(fullAddress);
        onChange(fullAddress, true);
        setBlurred(true);
        onBlur();
    };
    var handleBlur = function () {
        setBlurred(true);
        if (!inputValue.trim() || !isValidSelection) {
            invalidate();
            return;
        }
        onChange(inputValue, true);
        onBlur();
    };
    var handleInputChange = function (e) {
        var value = e.currentTarget.value;
        setInputValue(value);
        setIsValidSelection(false);
        onChange(value, false);
        if (!value.trim()) {
            onChange("", false);
        }
    };
    var showError = !field.isValid && blurred;
    var showSuccess = field.isValid && blurred && field.fieldValue !== "";
    var fieldClass = [
        fieldConfig.className || "",
        showError ? "field-error" : "",
        showSuccess ? "field-success" : "",
    ]
        .filter(Boolean)
        .join(" ")
        .trim();
    return (_jsxs("div", { className: "textbox", children: [fieldConfig.labelText ? (_jsx("label", { htmlFor: fieldConfig.fieldId, children: fieldConfig.labelText })) : (_jsx("label", { htmlFor: fieldConfig.fieldId, className: "visually-hidden", children: fieldConfig.placeHolder || "Property Address" })), _jsx(Autocomplete, { apiKey: GOOGLE_API_KEY, options: {
                    types: ["address"],
                    componentRestrictions: { country: "us" },
                    bounds: biasAwayFromNYBounds,
                    strictBounds: true,
                }, onPlaceSelected: handlePlaceSelect, value: inputValue, onChange: handleInputChange, onBlur: handleBlur, placeholder: fieldConfig.placeHolder || "Enter property address", className: fieldClass, autoComplete: fieldConfig.autoComplete || "off", autoCorrect: fieldConfig.autoCorrect || "off", spellCheck: fieldConfig.spellCheck || false, "aria-invalid": showError ? "true" : "false" })] }));
}
